import React, { FC, Fragment } from 'react'

import { Text } from 'components/ui-kit'
import { ConfirmationDialog } from 'components/dialog/ConfirmationDialog'

import styles from './BlockedModalView.module.scss'

interface Props {
  handleHide: () => void
  isOpen: boolean
  portalUrl: string
}

export const BlockedModalView: FC<Props> = ({ isOpen, portalUrl, handleHide }) => (
  <ConfirmationDialog
    show={isOpen}
    title="Account Can’t be Created"
    showFooter={false}
    onHide={handleHide}
    className={styles.blockedModalView}>
    <Fragment>
      <Text type="body-1">
        Looks like you have already applied for a job. You can login to the system and continue your existing
        application <a href={portalUrl}>here</a>.
      </Text>
      <br />
      <Text type="body-1">If you have no active job application, please contact support.</Text>
    </Fragment>
  </ConfirmationDialog>
)
